import styled from 'styled-components';

export const Container = styled.div`
  background: #FFFFFF;
  border-radius: 8px;
  padding: 24px 18px;
  font-family: 'Mangueira', sans-serif;

  @media (max-width: 600px) {
    padding: 24px 12px;
  }
`;

export const Scrollbar = styled.div`
  height: 87vh;
  ::-webkit-scrollbar-track {
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #F5F5F5;
  }
  ::-webkit-scrollbar-thumb {
    background: #F5F5F5;
  }
`;

export const BoxPadding = styled.div`
  padding: 0px 20px;
  margin-top: 20px;
`

export const ItemsWrap = styled.div`
  margin-top: 14px;
`
